import React from 'react';

import isString from 'lodash/isString';

import { useClassnames } from '@lumapps/classnames';
import { Theme, useTheme } from '@lumapps/lumx/react';
import { isUrl } from '@lumapps/utils/string/isUrl';
import { ElementRender } from '@lumapps/wrex/types';

import { IframeElement } from '../../../types';

import './index.scss';

export const CLASSNAME = 'wrex-iframe';

export const Iframe: ElementRender<IframeElement, HTMLDivElement> = ({
    element,
    elementRef,
    children,
    className,
    ...forwardedProps
}) => {
    const theme = useTheme() || Theme.light;
    const { block, element: elementClassName } = useClassnames(CLASSNAME);
    const { src, title, provider } = element ?? {};

    const isSrcUrl = isString(src) && isUrl(src);

    return (
        <div className={block({ [`theme-${theme}`]: true }, [className])} ref={elementRef} {...forwardedProps}>
            {children}
            <iframe
                className={elementClassName('iframe')}
                title={title}
                src={isSrcUrl ? src : undefined}
                srcDoc={!isSrcUrl ? (src as { doc: string }).doc : undefined}
                loading="lazy"
                allow="fullscreen"
                sandbox="allow-scripts allow-same-origin"
                contentEditable={false}
                data-provider={provider}
            />
        </div>
    );
};

Iframe.displayName = 'iframe';
